<template>
    <RouterLink to="to">{{ text }}</RouterLink>
</template>

<script setup>
const props = defineProps({
    to: String,
    text: String
})
</script>